var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40px",
    height: "40px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#FFFFFF",
    d: "M476.007,209.804c25.297-25.281,37.25-58.859,35.891-91.984l-16.484-16.484l-57.453,57.453l-66.844-17.906 l-17.906-66.828l57.453-57.453l-16.484-16.5c-33.125-1.359-66.703,10.594-91.984,35.891c-31.734,31.734-42.484,76.5-32.25,117.063 L78.663,344.335c-19.703,1.234-39.031,9.359-54.078,24.406c-32.781,32.781-32.781,85.906,0,118.688 c32.766,32.766,85.906,32.766,118.672,0c15.047-15.047,23.172-34.391,24.406-54.078l191.281-191.281 C399.506,252.288,444.272,241.538,476.007,209.804z M264.256,219.819c7.703-7.719,20.219-7.719,27.922,0 c7.719,7.703,7.719,20.219,0,27.938l-100,100c-7.719,7.719-20.219,7.719-27.938,0c-7.703-7.719-7.703-20.219,0-27.938 L264.256,219.819z M92.756,468.179l-38.594-10.344l-10.344-38.594l28.25-28.25l38.609,10.328l10.344,38.609L92.756,468.179z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanner);
export default __webpack_public_path__ + "static/media/spanner.add8f135eb5aeac950f8a4fb6516b487.svg";
export { ForwardRef as ReactComponent };